import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const useUpdateGlobalMergePath = () => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: (payload) =>
      axios.patch('api/v2/agent/search/metric/global-merge-path', payload),
    onError: (error) => {
      addNotification({ type: 'error', title: error.message });
    },
  });
};
